import MarkdownComponent from 'components/shared/MarkdownComponent';
import Modal from 'components/shared/Modal';
import { useI18n } from 'hooks/useI18n';
import ReactModal from 'react-modal';
import { StyledWrapper } from './CVApplicationsCoverLetterModalComponent.styled';

type Props = {
  isOpen: boolean;
  coverLetter: string;
  close?: () => void;
};

const CVApplicationsCoverLetterModalComponent: React.FC<Props> = ({
  isOpen,
  coverLetter,
  close
}) => {
  const { t } = useI18n('cv-applications-view');

  const title = t('cvApplicationsView.modalCoverLetter.title');

  return (
    <ReactModal isOpen={isOpen} contentLabel={title} onRequestClose={close}>
      <Modal onClose={close} title={title}>
        <StyledWrapper>
          <MarkdownComponent content={coverLetter} />
        </StyledWrapper>
      </Modal>
    </ReactModal>
  );
};

export default CVApplicationsCoverLetterModalComponent;
